import css from './service-pagination-card.module.scss';

export default function ServicePaginationCard({ onClick }: Readonly<{ onClick: () => void }>) {
  return (
    <div className={css.servicePaginationCard}>
      <button onClick={onClick}>Більше</button>
    </div>
  );
}
